export interface OauthState {
  dataSource: DataSource
  initilised: boolean
  loading: boolean
  message: string
  credentials: string
  state: any
}

export const initialState = {
  dataSource: null,
  initilised: false,
  loading: false,
  message: '',
  credentials: '',
  state: {},
}

export const oauth = (
  state: OauthState = initialState,
  action: ReduxAction,
): OauthState => {
  switch (action.type) {
    case 'START_OAUTH':
      return {
        ...state,
        dataSource: action.payload,
        initilised: true,
        loading: true,
        message: '',
        credentials: '',
        state: {},
      }
    case 'SET_CREDENTIALS_OAUTH': {
      const { credentials, dataSource } = action.payload
      return {
        ...state,
        dataSource,
        initilised: true,
        loading: false,
        message: '',
        credentials,
        state: {},
      }
    }
    case 'FINISH_OAUTH': {
      const { success, res } = action.payload
      const { error, data } = res
      const { state: resultState } = data || {}

      return {
        ...state,
        initilised: true,
        loading: false,
        message: !success ? error.message : '',
        credentials: !success ? '' : data.credentials,
        state: resultState?.state || {},
      }
    }
    default:
      return state
  }
}
